<template>
  <div>
    <!-- Table -->
    <div class="has-background-white pa-md rounded-lg">
      <b-table
        :data="adjustments"
        :mobile-cards="false"
        :loading="loading"
        hoverable
        class="rounded-lg is-size-7">
        <template>
          <b-table-column
            label="Shipping Method"
            cell-class="nowrap"
            v-slot="props">
            {{ props.row.shipping_method.name }}
          </b-table-column>
          <b-table-column
            label="Adjustment Code"
            cell-class="nowrap"
            v-slot="props">
            {{ props.row.adjustment_code.description || props.row.adjustment_code.code }}
          </b-table-column>
          <b-table-column
            label="Amount Type"
            cell-class="nowrap"
            v-slot="props">
            {{ $utils.upperFirst(props.row.adjustment_amount_type) }}
          </b-table-column>
          <b-table-column
            label="Amount"
            cell-class="nowrap"
            v-slot="props">
            <span v-if="props.row.adjustment_amount_type === 'percent'">
              {{ $numbers(props.row.adjustment_amount).format({ mantissa: 2 }) }}%
            </span>
            <span v-else>
              {{ $numbers(props.row.adjustment_amount).formatCurrency({ mantissa: 2 }) }}
            </span>
          </b-table-column>
          <b-table-column
            v-if="context.isMerchant()"
            label=""
            centered
            width="48"
            v-slot="props">
            <b-dropdown position="is-bottom-left">
              <button class="button is-outlined is-small" slot="trigger">
                <b-icon icon="dots-vertical"></b-icon>
              </button>
              <b-dropdown-item has-link>
                <a href="#" @click.prevent="openEditModal(props.row)" >Edit</a>
              </b-dropdown-item>
              <b-dropdown-item has-link>
                <a href="#" @click.prevent="confirmDelete(props.row)" class="has-text-danger">Delete</a>
              </b-dropdown-item>
            </b-dropdown>
          </b-table-column>
        </template>
        <template #empty>
          <div class="py-xxl has-text-centered">
            <p class="has-text-grey mb-md">There are no shipping adjustments associated with this connection.</p>
            <b-button
              v-if="context.isMerchant()"
              type="is-primary"
              outlined
              @click.prevent="openAddModal()"
            >Add Adjustment</b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- Add / Edit Modal -->
    <b-modal
      v-if="showModal"
      has-modal-card
      :active.sync="showModal"
      :can-cancel="['escape', 'x']"
    ><ShippingAdjustmentsModal
      :connection="connection"
      :adjustment="editingAdjustment"
      @saved:adjustment="onSaved"
    /></b-modal>
    <!-- Delete Confirmation Modal -->
    <b-modal
      v-if="showDeleteModal"
      has-modal-card
      :active.sync="showDeleteModal"
      :can-cancel="['escape', 'x']"
    ><ConfirmationModal
      label="Delete Adjustment"
      reason="Are you sure you want to delete this adjustment? This action cannot be undone."
      messageType="is-danger"
      confirmButtonText="Delete"
      confirmButtonType="is-danger"
      :saving="deleting"
      @modal:confirm="deleteAdjustment"
      @modal:close="showDeleteModal = false"
    /></b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ConfirmationModal from '@/components/Modals/ConfirmationModal'
import ShippingAdjustmentsModal from '@/components/Models/Connection/Modals/ShippingAdjustmentsModal'

export default {
  components: {
    ConfirmationModal,
    ShippingAdjustmentsModal
  },
  computed: {
    ...mapGetters(['context']),
    adjustments () {
      return this.connection.connection_service_level_adjustments || []
    },
    endpoint () {
      return this.context.route + '/connections/' + this.connection.id + '/'
    }
  },
  data () {
    return {
      showModal: false,
      editingAdjustment: null,
      showDeleteModal: false,
      deletingAdjustment: null,
      deleting: false
    }
  },
  methods: {
    openAddModal () {
      this.editingAdjustment = null
      this.showModal = true
    },
    openEditModal (adjustment) {
      this.editingAdjustment = adjustment
      this.showModal = true
    },
    onSaved () {
      this.showModal = false
      this.editingAdjustment = null
      this.$emit('updated')
    },
    confirmDelete (adjustment) {
      this.deletingAdjustment = adjustment
      this.showDeleteModal = true
    },
    deleteAdjustment () {
      const adjustment = this.deletingAdjustment
      const body = {
        connection_service_level_adjustments: [{
          id: adjustment.id,
          shipping_method: { id: adjustment.shipping_method.id },
          adjustment_code: { code: adjustment.adjustment_code.code },
          adjustment_amount_type: adjustment.adjustment_amount_type,
          adjustment_amount: adjustment.adjustment_amount,
          description: adjustment.description,
          delete: 1
        }]
      }
      this.deleting = true
      this.$http.patch(this.endpoint, body).then(() => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Adjustment deleted!' })
        this.showDeleteModal = false
        this.deletingAdjustment = null
        this.$emit('updated')
      }).catch(() => {
        this.$buefy.toast.open({ type: 'is-danger', message: 'An unexpected error occurred.' })
      }).finally(() => {
        this.deleting = false
      })
    }
  },
  props: ['connection', 'loading']
}
</script>
